import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import styled from "styled-components";


export const StyledTitle = styled(Styled.H2)`
margin-bottom:14px;
@media screen and (max-width: 1000px) {
margin-bottom:6px;
}
@media screen and (min-width: 1440px) {
     width:50%;
}
`